import { Injectable } from '@angular/core';
import { IEntity, IFile, IMergeFile, INamedEntity } from 'interfaces-lib';
import { AsyncSubject, Observable, Subject } from 'rxjs';

export interface IS3File {
  key: string;
}

export interface ILocalMergeFile extends IMergeFile {
  file: File;
}

export interface IS3MergeFile extends IMergeFile {
  s3: any;
}

export enum MergeStatus {
  STARTED = 'STARTED',
  UPDATE = 'UPDATE',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
}

@Injectable({ providedIn: 'root' })
export class MergeControllerService {
  private addToBasketSubject = new Subject<IMergeFile>();
  addToBasket$ = this.addToBasketSubject.asObservable();

  private removeFromBasketSubject = new Subject<IMergeFile>();
  removeFromBasket$ = this.removeFromBasketSubject.asObservable();

  private saveFileToEntitySubject = new Subject<{
    file: ILocalMergeFile;
    result: AsyncSubject<IMergeFile>;
  }>();
  saveFileToEntity$ = this.saveFileToEntitySubject.asObservable();

  private getMergeFilesRequestSubject = new Subject<AsyncSubject<IMergeFile[]>>();
  getMergeFilesRequest$ = this.getMergeFilesRequestSubject.asObservable();

  private mergeStatusSubject = new Subject<{
    mergeStatus: MergeStatus;
    entity: IEntity;
    status?: string;
  }>();
  mergeStatus$ = this.mergeStatusSubject.asObservable();

  addToBasket(file: IMergeFile): void {
    this.addToBasketSubject.next(file);
  }

  removeFromBasket(file: IMergeFile): void {
    this.removeFromBasketSubject.next(file);
  }

  saveFileToEntity(file: ILocalMergeFile): Observable<IMergeFile> {
    const result = new AsyncSubject<IMergeFile>();
    this.saveFileToEntitySubject.next({ file: file, result: result });
    return result.asObservable();
  }

  getMergeFilesInBasket(): Observable<IMergeFile[]> {
    const result = new AsyncSubject<IMergeFile[]>();
    this.getMergeFilesRequestSubject.next(result);
    return result.asObservable();
  }

  mergeStatus(mergeStatus: MergeStatus, entity: IEntity, status?: string): void {
    this.mergeStatusSubject.next({ mergeStatus, entity, status });
  }
}
